<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { type RoutePointAlertsType } from './AssignmentApi';
    import VehicleLimitList from './VehicleLimitList.svelte';
    import { VehicleLimitItem } from './VehicleLimit/VehicleLimitItem';
    import { tooltip } from '@svelte-plugins/tooltips';

    export let alerts: RoutePointAlertsType;

    let pieTemplate: string = `<svg xmlns="http://www.w3.org/2000/svg" width="128" height="128" viewBox="0 0 128 128" fill="none">
        <circle cx="64" cy="64" r="64" fill="{color}99"/>
        <path d="M64 64V0{arc}Z" fill="{color}"/>
    </svg>`;
    let pieSrc: string = '';

    let percent: number | null = null;

    let currentAlerts: string = '';
    let reloadAlerts: boolean = false;

    $: {
        percent = null;
        for (let type in alerts) {
            if (alerts[type].limit && typeof(alerts[type].value) == 'number') {
                percent = Math.max(alerts[type].value/alerts[type].limit, percent || 0);
            }
        }

        if (percent !== null) {
            percent = Math.round(percent*100);

            let color: string = '';
            if (percent > 100) {
                color = VehicleLimitItem._VEHICLE_LIMIT_COLOR_ERROR;
            } else if (percent > 90) {
                color = VehicleLimitItem._VEHICLE_LIMIT_COLOR_WARNING;
            } else {
                color = VehicleLimitItem._VEHICLE_LIMIT_COLOR_SUCCESS;
            }

            let angle = (Math.min(percent, 100) / 100) * 2 * Math.PI;
            let arcEndX = 64 + Math.sin(angle) * 64;
            let arcEndY = 64 - Math.cos(angle) * 64;
            let arcs = [];
            if (angle > Math.PI) {
                arcs.push('A64 64 0 0 1 64 128');
                arcs.push('A64 64 0 0 1 '+arcEndX+' '+arcEndY);
            } else {
                arcs.push('A64 64 0 0 1 '+arcEndX+' '+arcEndY);
            }

            if (alerts.non_normative_size?.value) {
                color = VehicleLimitItem._VEHICLE_LIMIT_COLOR_WARNING;;
            }

            pieSrc = 'data:image/svg+xml;base64,'+btoa(pieTemplate.replace(/\{color\}/g, color).replace('{arc}', arcs.join('')));
        }

        if (currentAlerts && currentAlerts != JSON.stringify(alerts)) {
            reloadAlerts = true;
            setTimeout(function(){ reloadAlerts = false; }, 0);
        }
        currentAlerts = JSON.stringify(alerts);
    }
</script>

{#if !reloadAlerts}
<span class="container" use:tooltip={{content: {component: VehicleLimitList, props: {alerts: alerts, values: true, percent: true, units: true, load: true, title: $_('Vehicle_load')}}, theme: 'lastmile-tooltip', maxWidth: 400}} style="align-self: center">
    <img src="{pieSrc}"/>
</span>
{/if}

<style>
    .container {
        display: inline-block;
        /*padding-left: 3px;*/
    }
    .container img {
        vertical-align: middle;
        max-height: 16px;
    }
</style>
